export function getFromStorage(key: string): string | null {
  return sessionStorage.getItem(key);
}

export function setStorage(key: string, value: string) {
  sessionStorage.setItem(key, value);
}

export function clearStorage() {
  sessionStorage.clear();
}
